import React from 'react';
import { IInteriorMaterial2, IInteriorProductMaterial2 } from '../../../services/WebApiClient';
import { State } from '../../../util/useState2';
import { MatProps } from './MatProps';
import { SingleProductMaterialEditor } from './SingleProductMaterialEditor';


export function ProductMaterialsEditor(props: {
    interiorMaterials: IInteriorMaterial2[];
    productMaterials: IInteriorProductMaterial2[];
    matProps: State<MatProps[]>;
    productId: number;
    onChange: () => void;
}) {

    const materialProps = props.matProps.value;

    function updateMatProp(interiorMaterialId: number, newProp: Partial<MatProps>) {
        const idx = materialProps.findIndex(mp => mp.id === interiorMaterialId);
        if (idx < 0)
            return;
        const newMat = {
            ...materialProps[idx],
            ...newProp
        };
        const newList = [...materialProps];
        newList[idx] = newMat;
        props.matProps.set(newList);
    }

    return (
        <>
            {materialProps.map(matProp => (

                <SingleProductMaterialEditor
                    matProp={matProp}
                    updateMatProp={updateMatProp}
                    productId={props.productId}
                    onChange={props.onChange}
                    key={matProp.id}
                />

            ))}
        </>
    );
}
